module.exports = __webpack_public_path__ + "media/sales/arrow-44efd263.svg";